<template>
  <div>
    <MenuBar />

    <div id="privacyPage" class="mobileOnly">
      <FloatingMenu />

      <transition enter-active-class="animated fadeIn" appear>
        <div class="privacyPageTitle">
          <span v-if="this.langChosen === 'gr'">개인 정보 정책</span>
          <span v-else>Privacy Policy</span>
        </div>
      </transition>

      <div class="heroImage" />

      <div class="contactContainer" v-if="this.langChosen === 'gr'">
        <p>
          방문자는 법률에서 요구하는 특정 예외에 따라 전자 정보를 포함하여 말레이시아 대중이 보유한 대부분의 문서 및
          기록이 말레이시아 법률에 따라 공개 된 기록임을 알아야합니다. 따라서이 웹 사이트를 통해 제출 된 정보는 공공
          아카이브 요청에 따라 공개 될 수 있습니다. 말레이시아 법에 따라 보관해야하는 기록은 관련 파일 보관 일정에 따라
          보관 및 폐기됩니다.
        </p>

        <p>
          <b> 사용 통계 </b>
        </p>

        <p>
          웹 사이트 개선에 도움이되는 사용 통계를 생성합니다. 우리는 각 사이트 방문자에 대한 특정 정보를 자동으로
          수집합니다. 그러나이 정보는 공개되지 않았습니다. "개인 식별 정보"(예 : 이름, 주소, 전화 번호, 이메일 주소 등)
          이 사이트의 페이지를 보라는 요청을받을 때마다 파일은 당사 사이트는 일반적인 사용자 정보를 수집하는 로그 파일을
          생성합니다. 이러한 정보에는 인터넷 브라우저 또는 운영 체제 유형이 포함됩니다. 사용하는 컴퓨터 시스템,이
          사이트에 액세스 한 날짜 및 시간. 각 컴퓨터의 인터넷 프로토콜 주소 (또는 프록시 서버) 보낸 사람 이 사이트에
          링크하는 웹 사이트의 모든 요청 및 인터넷 주소. 서버 로그를 통해 수집 된 정보는 집합 적으로 만 사용됩니다.
          패턴을 만들고 추세와 통계를 분석 할 수 있습니다.
        </p>

        <p>
          <b>전자 양식 및 이메일</b>
        </p>
        <p>
          이 사이트는 개인 식별 정보를 수집하지 않습니다. (예 : 이름, 주소, 전화 번호 등) 이 정보를 자발적으로 제공하지
          않는 한. 다음과 같은 정보를 요청할 수 있습니다. 이 사이트의 대화 형 기능은 특정 관심사에 맞게 조정할 수
          있습니다. 그리고 당신의 필요 (선택한 관심사와 일치하는 정보를 주기적으로 홍보하는 것을 포함). 귀하는 요청 된
          정보를 제공하거나 제공하지 않아도됩니다. 당신이 선택한다면 이런 종류의 정보를 제공하지 마십시오. 여전히 거의
          모든 사이트를 방문 할 수 있습니다. 그러나 일부 온라인 포럼에는 참여하지 못할 수 있습니다. 개인 정보는 방문객과
          직원이 자발적으로 제공합니다. 전자 및 이메일 형식으로 전송 된 정보가 사용됩니다. 웹 사이트에 명시된 목적으로
          필요에 따라 다른 기관과 공유 할 수 있습니다. 법률 또는 기업 원칙에 따라 이 웹 사이트를 통해 제출 된 정보 공공
          기록 보관소의 요청에 따라 공개 될 수도 있습니다.
        </p>

        <p>
          <b>Web Cookies</b>
        </p>
        <p>
          이 사이트를 통해 정보를 제출하는 방문자는 그렇게 할 수 있음을 알아야합니다. 컴퓨터를이 웹 사이트에 연결하는
          정보를 만듭니다. 임시 ( "쿠키") 쿠키는 거래를 완료하는 데 필요할 때 사용될 수 있습니다. 인터넷을 통해 또는
          편의를 위해 당사에 전송 된 정보의 지속적인 처리 인터넷과의 상호 작용 당사 사이트에서 수집되는 정보에는 다음이
          포함됩니다. 쿠키는 공개 등록 요청에 의해 공개 될 수 있습니다.
        </p>
      </div>

      <div class="contactContainer" v-else>
        <p>
          Visitors should be aware that, subject to certain statutory exceptions, most documents and records maintained
          by Malaysiapools, including but not limited to electronic data, are public records under Malaysia law.
          Therefore, information submitted through this website may be subject to disclosure pursuant to a public
          records request. Records required to be maintained pursuant to the laws of Malaysia will be retained and
          disposed of in accordance with applicable record retention schedules.
        </p>

        <p>
          <b>Usage Statistics</b>
        </p>

        <p>
          In order to generate usage statistics to help us improve our website, we automatically collect certain
          information on every visitor to the website. However, this information does not disclose "personal
          identifiers" (such as name, address, telephone number, email address, etc.). Each time a request is made to
          view a page within this website, our website creates a log file capturing generic user information. Examples
          of this type of information includes the type of Internet browser or computer operating system you are using,
          the date and time you accessed this site, the Internet protocol address of the individual computer (or proxy
          server) making the request, and the Internet address of the site from which you may have linked to this site.
          All information collected by way of server log files is used in aggregate form only, and may be analyzed for
          trends and statistics.
        </p>

        <p>
          <b>Online Forms and Email</b>
        </p>
        <p>
          This website will not collect personally identifiable information (such as name, address, telephone number,
          etc.) unless you provide such information voluntarily. We may ask for such information so that we can tailor
          interactive features of this website to your specific interests and needs (including periodically forwarding
          information that matches your selected interests). You are free to provide or to not provide the requested
          information. If you choose to not provide this type of information, you can still visit most of the website,
          but you may be unable to participate in certain online forums. Any personal information voluntarily provided
          by visitors, including personal information submitted on online forms and email, will be used for the purposes
          stated on the web page and may also be shared with other agencies as required by law or pursuant to agency
          authority. Information submitted through this website also may be subject to disclosure pursuant to a public
          records request.
        </p>

        <p>
          <b>Web Cookies</b>
        </p>
        <p>
          Visitors who submit information via this website should be aware that data linking your computer to this
          website (a "cookie") may be created. Temporary cookies may be used when necessary to complete a transaction,
          to process data submitted to us online or to facilitate ongoing Internet interaction. Information collected on
          our websites, including cookies, may also be subject to disclosure pursuant to a public records request.
        </p>
      </div>
    </div>

    <div id="privacyDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div v-if="this.langChosen === 'gr'">개인 정보 정책</div>
          <div v-else>Privacy Policy</div>
        </transition>
      </div>

      <div class="flex">
        <LeftBannerAds />

        <div class="aboutDesktopField">
          <div v-if="this.langChosen === 'gr'">
            <p>
              방문자는 특정 예외에 따라 법이 말레이시아 인이 보관하는 대부분의 문서와 기록은 다음과 같습니다. 표시되는
              전자 데이터는 수백만 명의 말레이시아 법에 따라 공개 된 기록입니다. 따라서이 웹 사이트를 통해 제출 된
              정보가 공개 될 수 있습니다. 공공 아카이브 요청에 따라 기록은 말레이시아 법률에 따라 보관됩니다. 유지되며
              관련 파일 보존 일정에 따라 폐기됩니다.
            </p>

            <p>
              <b>사용 통계</b>
            </p>

            <p>
              사이트 개선에 도움이되는 사용 통계 생성 우리는 각 사이트 방문자에 대한 특정 정보를 자동으로 수집합니다.
              그러나 이러한 것들은 공개되지 않은 정보 "개인 식별 정보"(예 : 이름, 주소, 전화 번호, 이메일 주소 등) 그
              안에있는 페이지를 볼 때마다. 사이트 저희 사이트는 사용자에게 일반적인 정보를 수집하는 로그를 생성합니다.
              이러한 정보의 예는 브라우저의 유형입니다. 사용하는 인터넷 또는 컴퓨터 운영 체제, 사용중인 날짜 및 시간 이
              사이트 인터넷 주소에 액세스 요청을 보내는 각 컴퓨터 (또는 프록시)의 프로토콜과 웹 사이트의 인터넷 주소 이
              사이트에 링크 한 항목 로그 파일을 통해 수집 된 모든 정보. 서버는 집계 된 모델에서만 사용되며 추세를
              분석하고 통계 데이터
            </p>

            <p>
              <b>전자 양식 및 이메일</b>
            </p>

            <p>
              이 사이트는 개인 식별 정보를 수집하지 않습니다. (예 : 이름, 주소, 전화 번호 등) 이 정보를 자발적으로
              제공하지 않는 한. 그러한 정보를 요청할 수 있습니다. 이 사이트의 대화 형 기능을 특정 특성에 맞게 조정할 수
              있습니다. 당신의 관심과 필요 (정기적으로 관련 정보 홍보 포함 원하는 관심으로) 요청한 정보를 제공하거나
              지정하지 않아도됩니다. 이러한 유형의 정보를 제공하지 않기로 선택한 경우에도 그렇게 할 수 있습니다.
              대부분의 웹 사이트를 방문합니다. 그러나 개인 정보에 대한 온라인 포럼에 참여하지 못할 수도 있습니다.
              방문자가 자발적으로 제공하는 것 여기에는 전자 및 전자 형식으로 전송 된 개인 정보가 포함됩니다. 서신은 웹
              사이트에 명시된 목적으로 사용되며 다른 조직과 공유 법률 또는 기업 원칙에 따라 이 웹 사이트를 통해 제출 된
              정보도 공개 될 수 있습니다. 공공 아카이브 요청에 따라
            </p>

            <p>
              <b>Web Cookies</b>
            </p>

            <p>
              이 사이트를 통해 정보를 제출하는 방문자는 그렇게 할 수 있음을 알아야합니다. 귀하의 컴퓨터를이 웹 사이트에
              연결하는 정보 ( "쿠키")를 일시적으로 생성합니다. 거래를 완료하기 위해 필요한 경우 쿠키를 사용할 수
              있습니다. 인터넷을 통해 또는 편의를 위해 당사에 전송 된 정보의 지속적인 처리 인터넷과의 상호 작용 당사
              사이트에서 수집되는 정보에는 다음이 포함됩니다. 쿠키는 공개 등록 요청에 의해 공개 될 수도 있습니다.
            </p>
          </div>

          <div v-else>
            <p>
              Visitors should be aware that, subject to certain statutory exceptions, most documents and records
              maintained by Malaysiapools, including but not limited to electronic data, are public records under
              Malaysia law. Therefore, information submitted through this website may be subject to disclosure pursuant
              to a public records request. Records required to be maintained pursuant to the laws of Malaysia will be
              retained and disposed of in accordance with applicable record retention schedules.
            </p>

            <p>
              <b>Usage Statistics</b>
            </p>

            <p>
              In order to generate usage statistics to help us improve our website, we automatically collect certain
              information on every visitor to the website. However, this information does not disclose "personal
              identifiers" (such as name, address, telephone number, email address, etc.). Each time a request is made
              to view a page within this website, our website creates a log file capturing generic user information.
              Examples of this type of information includes the type of Internet browser or computer operating system
              you are using, the date and time you accessed this site, the Internet protocol address of the individual
              computer (or proxy server) making the request, and the Internet address of the site from which you may
              have linked to this site. All information collected by way of server log files is used in aggregate form
              only, and may be analyzed for trends and statistics.
            </p>

            <p>
              <b>Online Forms and Email</b>
            </p>
            <p>
              This website will not collect personally identifiable information (such as name, address, telephone
              number, etc.) unless you provide such information voluntarily. We may ask for such information so that we
              can tailor interactive features of this website to your specific interests and needs (including
              periodically forwarding information that matches your selected interests). You are free to provide or to
              not provide the requested information. If you choose to not provide this type of information, you can
              still visit most of the website, but you may be unable to participate in certain online forums. Any
              personal information voluntarily provided by visitors, including personal information submitted on online
              forms and email, will be used for the purposes stated on the web page and may also be shared with other
              agencies as required by law or pursuant to agency authority. Information submitted through this website
              also may be subject to disclosure pursuant to a public records request.
            </p>

            <p>
              <b>Web Cookies</b>
            </p>

            <p>
              Visitors who submit information via this website should be aware that data linking your computer to this
              website (a "cookie") may be created. Temporary cookies may be used when necessary to complete a
              transaction, to process data submitted to us online or to facilitate ongoing Internet interaction.
              Information collected on our websites, including cookies, may also be subject to disclosure pursuant to a
              public records request.
            </p>
          </div>
        </div>

        <RightBannerAds />
      </div>
    </div>

    <FifthSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FifthSection from '../components/FifthSection';
import MenuBar from '../components/MenuBar';
import LeftBannerAds from '../components/LeftBannerAds';
import RightBannerAds from '../components/RightBannerAds';

export default {
  components: {
    FloatingMenu,
    FifthSection,
    MenuBar,
    LeftBannerAds,
    RightBannerAds,
  },

  mounted() {
    this.setDocTitle();
  },

  methods: {
    setDocTitle() {
      if (localStorage.getItem('langChosen') === 'gr') {
        document.title = '개인 정보 정책 - 부산 복권';
      } else {
        document.title = 'Privacy Policy - Busan Lotteries';
      }
    },
  },
};
</script>

<style>
#privacyPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  padding: 5vw;
  padding-top: 3.75vh;
  box-sizing: border-box;
}

.privacyPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
  margin-bottom: 5.5vw;
}

#privacyPage .heroImage {
  height: 35vh;
  background: url('../assets/privacy.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 2vw 2vw 0 0;
  overflow: hidden;
}

.contactContainer {
  background-color: white;
  padding: 4vw;
  border-radius: 0 0 2vw 2vw;
  font-size: 0.98em;
  line-height: 175%;
}

.contactContainer p {
  margin: 0;
  margin-bottom: 3vw;
}

.contactContainer p:last-child {
  margin-bottom: 1vw;
}

#privacyDesktop {
  display: none;
}

@media screen and (min-width: 768px) {
  #privacyDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
    display: block;
  }

  #privacyDesktop .heroHeader {
    background-image: url('../assets/privacy.jpg'),
      linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6));
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: top;
    text-shadow: 1px 1px 4px black;
  }

  .aboutDesktopField {
    line-height: 150%;
    font-size: 1.2em;
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 15px 40px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  #privacyDesktop .adsSpace1,
  #privacyDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
}
</style>
